import { useState } from "react";
import AddJournalVoucher from "../FormComponents/AddJournalVoucher/AddJournalVoucher";
import AddPaymentAccount from "../FormComponents/AddBankPayment/AddBankPayment";
import AddBankReceipt from "../FormComponents/AddBankReceipt/AddBankReceipt";
import AddcashReceipt from "../FormComponents/AddCashReciept/AddCashReciept";
import AddCashPayment from "../FormComponents/AddCashPayment/AddCashPayment";
import AddContra from "../FormComponents/AddContra/AddContra";
import { replaceUnderscore } from "../../../CommonFunction/common";
import { useDispatch } from "react-redux";
export const SingleVoucher = ({
  el,
  className,
  key,
  ParentPortalCloseFunction,
  AddComp, ReferenceFieldName, ReferFormKey
}) => {
  const [type, setType] = useState("");
  const [show, setshow] = useState(false);
  const dispatch = useDispatch()
  const handleDoubleClick = (el) => {
    if (AddComp) {
      dispatch({
        type: "SET_COMPONENT_PROP",
        payload: {
          Table_Key: el,
          props: {
            ParentPortalCloseFunction: () => {
              setshow(false);
            },
            show: show,
            TypeOfPortal: "Add",
            ReferenceFieldName, ReferFormKey
          },
        },
      });
    }
    setType(el);
    setshow(true);
    setTimeout(() => {
      setshow(false);
    }, 3000);
  };


  return (
    <div key={key}>
      <div className={className} onClick={() => handleDoubleClick(el)}>
        {replaceUnderscore(el)}
      </div>

      {type === "Journal Voucher" ? (
        <AddJournalVoucher
          show={show}
          TypeOfPortal="Add"
          submitType={"Save"}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
        />
      ) : type === "Bank Payment" ? (
        <AddPaymentAccount
          show={show}
          TypeOfPortal="Add"
          submitType={"Save"}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
        />
      ) : type === "Bank Receipt" ? (
        <AddBankReceipt
          show={show}
          TypeOfPortal="Add"
          submitType={"Save"}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
        />
      ) : type === "Cash Payment" ? (
        <AddCashPayment
          show={show}
          TypeOfPortal="Add"
          submitType={"Save"}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
        />
      ) : type === "Cash Receipt" ? (
        <AddcashReceipt
          show={show}
          TypeOfPortal="Add"
          submitType={"Save"}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
        />
      ) : type === "Contra" ? (
        <AddContra
          show={show}
          TypeOfPortal="Add"
          submitType={"Save"}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
        />
      ) : (
        <></>
      )}
    </div>
  );
};
